import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { BaselineBarChartIcon, GiftIcon, MapViewIcon } from "../../../../theme/assets";
import DisplayElementsList from "../DisplayElementsList/DisplayElementsList";

import ButtonBarOrCarousel from "../ButtonBarOrCarousel/ButtonBarOrCarousel";
function EngineButtonBar({
  className,
  onOpenPromotions,
  onOpenMap,
  onOpenCalendar,
  isPropertyChain,
  showPromotions,
  showAvailability,
  displayElements,
  onSelectDisplay,
  carousel = false,
  propertyPromotions,
}) {
  const buttonBarList = [];
  const dropdownList = [];
  let buttonItem = null;
  const hasDisplayElements = displayElements && displayElements.length > 0;
  // TODO: requiring the ticker to have map in the ticker is too custom, FIX this
  const hasCustomMap = hasDisplayElements && displayElements.find(el => el.ticker.includes("map"));

  if (showPromotions && !carousel) {
    buttonItem = {
      key: "promotions",
      label: "promotions",
      icon: <GiftIcon />,
      hide: true,
      hasBadge: true,
      handleClick: onOpenPromotions,
    };

    buttonBarList.push(buttonItem);
    dropdownList.push(buttonItem);
  }

  if (!isPropertyChain && showAvailability) {
    buttonItem = {
      key: "availability",
      label: "availability",
      icon: <BaselineBarChartIcon />,
      handleClick: onOpenCalendar,
    };

    buttonBarList.push(buttonItem);
    dropdownList.push(buttonItem);
  }
  if (!hasCustomMap) {
    buttonItem = {
      key: "map",
      label: "map",
      icon: <MapViewIcon />,
      handleClick: onOpenMap,
    };
    if (!hasDisplayElements) {
      buttonBarList.push(buttonItem);
    } else {
      dropdownList.push(buttonItem);
    }
  }
  if (hasDisplayElements) {
    displayElements.map(element => {
      dropdownList.push({
        key: element.ticker,
        label: element.label,
        icon: element.ticker.includes("map") ? <MapViewIcon /> : null,
        handleClick: event =>
          onSelectDisplay({
            event,
            element: element.ticker,
            renderAsModal: true,
          }),
      });
    });

    buttonBarList.push({
      key: "more",
      icon: <DisplayElementsList elements={dropdownList} />,
    });
  }

  return (
    <ButtonBarOrCarousel
      carousel={carousel}
      propertyPromotions={propertyPromotions}
      onOpenPromotions={onOpenPromotions}
      buttonBarList={buttonBarList}
      className={className}
    />
  );
}

EngineButtonBar.propTypes = {
  /** ClassName */
  className: PropTypes.string,
  /** Function to be executed when clicking the back button */
  onOpenPromotions: PropTypes.func.isRequired,
  /** Function to be executed when clicking in the result's header */
  onOpenMap: PropTypes.func.isRequired,
  /** Function to be executed when clicking in the result's header */
  onOpenCalendar: PropTypes.func.isRequired,
  /** Function to be executed when clicking in the result's header */
  onSelectDisplay: PropTypes.func.isRequired,
  /** Filter node / content */
  isPropertyChain: PropTypes.bool.isRequired,
};

EngineButtonBar.defaultProps = {
  className: "",
};

export default pure(EngineButtonBar);
